import { Component, Input } from '@angular/core';
import { extensionGroupRoute } from 'src/app/app-routing.module';
import { ExtensionGroupDetailLinkModel } from '../models/extension-group-detail-link.model';

@Component({
    selector: 'ndt-extension-group-detail-link',
    templateUrl: './extension-group-detail-link.component.html',
    styleUrls: ['../detail-links.scss'],
    standalone: false
})
export class ExtensionGroupDetailLinkComponent {
   @Input() extensionGroup: ExtensionGroupDetailLinkModel | null;
   @Input() header: string;
   extensionGroupRoute = extensionGroupRoute;
}
